module.exports = __webpack_public_path__ + "static/nobox-green-88d19db9f717f12186d76b24d038937e.png";